var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.4,1.6H1.6C0.7,1.6,0,2.3,0,3.2l0,9.6c0,0.9,0.7,1.6,1.6,1.6h12.8c0.9,0,1.6-0.7,1.6-1.6V3.2C16,2.3,15.3,1.6,14.4,1.6z\n\t M14.4,12.8H1.6v-8l6.4,4l6.4-4V12.8z M8,7.2l-6.4-4h12.8L8,7.2z","fill":"currentColor"}));
}

Mail.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Mail;

Mail.default = Mail;
